import type { IBulkAddTraitResult } from "@apis/traits/types"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@components/ui/table"

type TBulkAddTraitsSummaryProps = {
  result: IBulkAddTraitResult
}

export const BulkAddTraitsSummary = ({
  result,
}: TBulkAddTraitsSummaryProps) => {
  const duplicates = result.received - result.processed

  return (
    <div
      className="tw:mt-6 tw:rounded-md tw:border tw:border-border tw:p-4"
      role="status"
    >
      <h4 className="tw:mb-2 tw:font-semibold">Result</h4>
      <ul className="tw:list-disc tw:pl-5 tw:text-sm">
        <li>{result.processed} accounts processed</li>
        <li>{result.added} traits added</li>
        <li>{result.already_had} accounts already had the trait</li>
        <li>{result.failed.length} accounts failed</li>
        {duplicates > 0 && (
          <li>{duplicates} duplicated or invalid account ids were ignored</li>
        )}
      </ul>

      {result.failed.length > 0 && (
        <div className="tw:mt-4">
          <h5 className="tw:mb-2 tw:font-semibold">Failed accounts</h5>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Account ID</TableHead>
                <TableHead>Error</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {result.failed.map((failure) => (
                <TableRow key={failure.account_id}>
                  <TableCell>{failure.account_id}</TableCell>
                  <TableCell>{failure.error}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  )
}
